<template>
  <div>
    <PageTitleVue>
      Editar Funcionário
    </PageTitleVue>
    <!-- <ContainerVue> -->
      <Form :descriptionTitle="'Editar dados do funcionário'">

        <ShiftForm
          :descriptionTitle="'Informações complementares'"
          :descriptionSubTitle="''"
        />

        <div class="w-full flex justify-center">
          <CreateButton
            @click="editEmployee"
            :label="'Salvar'"
            :icon="PhUserCheck"
          />
        </div>
      </Form>
    <!-- </ContainerVue> -->
    <FloatBackPage />
  </div>
</template>

<script setup>
import FloatBackPage from '@/components/Buttons/FloatBackPage.vue'
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import EmployeesService from '../services/employees.service'
import CreateButton from '@/components/Buttons/Create.vue'
import ContainerVue from '@/components/Container.vue'
import ShiftForm from './ShiftForm.vue'
import Form from './Form.vue'
import { cleanAllFormFields, setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataEmployee } from '../store'
import { useRoute } from 'vue-router'
import { storeApp } from '@/store'
import { onMounted } from 'vue'
import * as yup from './../../../validator'
import { PhUserCheck } from '@phosphor-icons/vue'

const employeeId = useRoute()
const store = dataEmployee
const appStore = storeApp.state

const schema = yup.object().shape({
  employee: yup.object().shape({
    name: yup.string().required().label('Nome').min(5),
    function: yup.string().required().label('Função'),
    registeredSince: yup.date().required('Admissão é um campo obrigatório'),
    phone: yup.string().required().label('Celular'),
    document: yup.object().shape({
      cpf: yup.string().label('CPF').required()
    }),
    address: yup.object().shape({
      city: yup.string().label('Cidade').required().min(1),
      country: yup.string().label('Bairro').required().min(1)
    })
  })
})

onMounted(async () => {
  store.commit('reset')
  await getEmployees()
})

async function getEmployees () {
  appStore.loading = true
  await EmployeesService.getEmployeeById(employeeId.params.id).then(res => {
    store.state.employee.address.city = res.data.city
    store.state.employee.address.country = res.data.address
    store.state.employee.address.number = res.data.number
    store.state.employee.document.cnh = res.data.cnh
    store.state.employee.document.cpf = res.data.cpf
    store.state.employee.document.rg = res.data.rg
    store.state.employee.email = res.data.email
    store.state.employee.function = res.data.role
    store.state.employee.name = res.data.name
    store.state.employee.phone = res.data.phone
    store.state.employee.registeredSince = res.data.registered
    store.state.employee.imgPath = res.data.image
    store.state.employee.photo = null

    store.state.employee.father = res.data.father
    store.state.employee.mother = res.data.mother
    store.state.employee.pis = res.data.pis
    store.state.employee.ctps = res.data.ctps
    store.state.employee.serie = res.data.serie
    store.state.employee.esocial = res.data.esocial
    store.state.employee.cbo = res.data.cbo
    store.state.employee.piso_salarial = res.data.piso_salarial
    store.state.employee.demissao = res.data.demissao

    appStore.loading = false
  }).catch(err => {
    appStore.loading = false
    toast(
      'Aviso',
      'Dados do funcionário não encontrados',
      'error'
    )
  })
}

async function editEmployee () {
  appStore.loading = true

  cleanAllFormFields()

  const validate = (await validateFormField(schema, store.state))

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    console.log(validate)
    appStore.loading = false
    return
  }

  if (
    store.state.employee.photo &&
      typeof (store.state.employee.photo) === 'object' &&
      typeof (store.state.employee.imgPath) === 'string' &&
      store.state.employee.imgPath !== '[]'
  ) {
    await EmployeesService.editImage(store.state.employee.photo, store.state.employee.imgPath).then(res => {
      store.state.employee.imgPath = res.data
      store.state.employee.photo = res.data
    }).catch(err => {
      toast(
        'Aviso',
        'Upload de novo arquivo não concluído',
        'error'
      )
    })
  } else if (
    store.state.employee.photo &&
    typeof (store.state.employee.photo) !== 'string'
  ) {
    await EmployeesService.saveImage(store.state.employee.photo).then(res => {
      store.state.employee.imgPath = res.data
      store.state.employee.photo = res.data
    }).catch(err => {
      toast(
        'Aviso',
        'Upload de arquivo não concluído',
        'warning'
      )
    })
  } else { store.state.employee.photo = store.state.employee.imgPath }

  store.state.employee.company_id = appStore.accessToken.getItem('__company')

  await EmployeesService.editEmployee(employeeId.params.id, store.state.employee).then(res => {
    toast(
      'Sucesso',
      'Dados do funcionário atualizados',
      'success'
    )
    appStore.loading = false
  }).catch(err => {
    toast(
      'Aviso',
      'Dados do funcionario não foram atualizados',
      'error'
    )
    appStore.loading = false
  })
}

</script>
